import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Menu, User } from 'lucide-react';
import { Button } from '#AdminPanelFrontend/components/ui/button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '#AdminPanelFrontend/components/ui/dropdown-menu';
import { ModeToggle } from '#AdminPanelFrontend/components/mode-toggle';
import logo from '#AdminPanelFrontend/styles/horse.png';
import { UserContext } from '#AdminPanelFrontend/contexts/UserContext';
import { useSso } from '#AdminPanelFrontend/contexts/SsoContext';
import { apiUrl } from '#AdminPanelFrontend/services/api';
import { socket } from '#AdminPanelFrontend/services/socket';

interface TopBarProps {
	toggleSidebar: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ toggleSidebar }) => {
	const context = useContext(UserContext);
	const ssoConfig = useSso();

	const logout = () => {
		context.dispatch({ type: 'LOGOUT' });

		if (ssoConfig.enabled && ssoConfig.logoutUrl) {
			const redirectToAuth0 = () => {
				window.location.href = apiUrl(ssoConfig.logoutUrl!);
			};

			socket.timeout(3000).emit('User:Logout', {}, () => {
				redirectToAuth0();
			});
			window.setTimeout(redirectToAuth0, 3500);
		}
	};

	return (
		<header className="bg-white dark:bg-gray-800 shadow-md p-4 flex justify-between items-center transition-all duration-300">
			<div className="flex items-center space-x-4">
				<Button variant="ghost" size="icon" onClick={toggleSidebar}>
					<Menu className="h-6 w-6" />
				</Button>
				<div className="flex items-center space-x-2">
					<img src={logo} alt="Logo" className="h-8 w-12" />
					<span className="text-xl font-bold hidden sm:inline dark:text-white">Cavalcando Admin Panel</span>
				</div>
			</div>
			<div className="flex items-center space-x-4">
				<ModeToggle />
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="ghost" size="icon">
							<User className="h-6 w-6" />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align="end">
						<DropdownMenuItem>
							<Link to="/settings">Settings</Link>
						</DropdownMenuItem>
						<DropdownMenuItem onClick={logout}>Logout</DropdownMenuItem>
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</header>
	);
};

export default TopBar;
